import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowRight, Clock, ShieldCheck, Mail } from 'lucide-react';

export const RegisterSuccess: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950 py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Background ambient glows */}
      <div className="absolute top-1/4 -left-20 w-96 h-96 bg-primary-600/10 rounded-full blur-[128px] pointer-events-none" />
      <div className="absolute bottom-1/4 -right-20 w-96 h-96 bg-emerald-600/10 rounded-full blur-[128px] pointer-events-none" />

      <div className="max-w-lg w-full relative z-10 animate-fade-in">
        <div className="bg-white dark:bg-slate-900 rounded-3xl shadow-xl border border-slate-200/80 dark:border-slate-800 p-8 sm:p-10 text-center">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-2xl bg-gradient-to-tr from-emerald-500 to-teal-400 text-white shadow-lg shadow-emerald-500/25 mb-6">
            <CheckCircle2 className="h-9 w-9" />
          </div>

          <h2 className="text-3xl font-extrabold text-slate-900 dark:text-white mb-3 tracking-tight">
            Registo Submetido com Sucesso!
          </h2>

          <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed mb-8">
            Obrigado pelo seu registo. A sua candidatura foi recebida e encontra-se agora em fase de
            revisão e validação pela nossa equipa de compliance.
          </p>

          {/* Stepper info */}
          <div className="space-y-3 mb-8 text-left bg-slate-50 dark:bg-slate-800/60 p-5 rounded-2xl border border-slate-100 dark:border-slate-750">
            <div className="flex items-start gap-3">
              <div className="w-7 h-7 rounded-full bg-emerald-100 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-400 flex items-center justify-center shrink-0 mt-0.5">
                <CheckCircle2 className="w-4 h-4" />
              </div>
              <div>
                <p className="text-xs font-bold text-slate-800 dark:text-slate-200">
                  1. Submissão dos Dados
                </p>
                <p className="text-xs text-slate-500 dark:text-slate-400">
                  Informação fiscal e contactos registados no sistema.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-7 h-7 rounded-full bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400 flex items-center justify-center shrink-0 mt-0.5">
                <Clock className="w-4 h-4" />
              </div>
              <div>
                <p className="text-xs font-bold text-slate-800 dark:text-slate-200">
                  2. Validação Operacional
                </p>
                <p className="text-xs text-slate-500 dark:text-slate-400">
                  A nossa equipa valida o NIF e perfil da empresa (até 24h úteis).
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-7 h-7 rounded-full bg-blue-100 dark:bg-blue-900/40 text-blue-600 dark:text-blue-400 flex items-center justify-center shrink-0 mt-0.5">
                <Mail className="w-4 h-4" />
              </div>
              <div>
                <p className="text-xs font-bold text-slate-800 dark:text-slate-200">
                  3. Ativação & Credenciais
                </p>
                <p className="text-xs text-slate-500 dark:text-slate-400">
                  Receberá um email com a confirmação de aprovação para criar as suas chaves de API.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <Link
              to="/login"
              className="btn-base btn-primary w-full py-3 text-sm font-bold flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
            >
              Ir para o Início de Sessão <ArrowRight className="w-4 h-4" />
            </Link>

            <div className="flex items-center justify-center gap-1.5 text-xs text-slate-400 pt-2">
              <ShieldCheck className="w-3.5 h-3.5 text-emerald-500" />
              <span>Ambiente regulado com proteção de dados e encriptação TLS</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
